import { render, staticRenderFns } from "./Message-push.vue?vue&type=template&id=86b25ef2"
import script from "./Message-push.vue?vue&type=script&lang=js"
export * from "./Message-push.vue?vue&type=script&lang=js"
import style0 from "./Message-push.vue?vue&type=style&index=0&id=86b25ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports